import { apiClient, PaginationSearchParams } from '@/shared/api'

import { TReview } from '../model/schema'

export type GetRecentReviewsParams = Pick<PaginationSearchParams, 'size'>

export const getRecentReviews = async (params: GetRecentReviewsParams = {}) => {
  const response = await apiClient.get<TReview[]>({
    endpoint: '/contracts/recent-reviews',
    queryParams: params,
  })

  return response
}
